"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedQueryWrapper = void 0;
var client_1 = require("@apollo/client");
var react_1 = __importDefault(require("react"));
var reselect_1 = require("reselect");
var shallowequal_1 = __importDefault(require("shallowequal"));
var PaginatedRowStore_1 = require("../dataGrid/PaginatedRowStore");
var GraphQLSliceable_1 = require("./GraphQLSliceable");
/**
 * The PaginatedQueryWrapper is a provider component that gives its children access to a paginated GraphQL query.
 */
var PaginatedQueryWrapper = /** @class */ (function (_super) {
    __extends(PaginatedQueryWrapper, _super);
    function PaginatedQueryWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /*
         * We use a custom memoizer for the row store that extracts the partial query variables from the props
         * and checks shallow equality on them separately, so that if the client passes in a new object
         * containing the same query variables, we don't obliterate the previous row store.
         */
        _this.memoizedCreateRowStore = (0, reselect_1.defaultMemoize)(createRowStore, function (a, b) { return (0, shallowequal_1.default)(a, b); });
        return _this;
    }
    PaginatedQueryWrapper.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(client_1.ApolloConsumer, null, function (client) {
            var _a = _this.props, children = _a.children, partialQueryVariables = _a.partialQueryVariables, rowFetcherParams = __rest(_a, ["children", "partialQueryVariables"]);
            var rowStore = _this.memoizedCreateRowStore(rowFetcherParams, partialQueryVariables, client);
            return children({ rowStore: rowStore });
        }));
    };
    return PaginatedQueryWrapper;
}(react_1.default.Component));
exports.PaginatedQueryWrapper = PaginatedQueryWrapper;
function createRowStore(sliceableFactoryParams, partialQueryVariables, client) {
    var queryRows = (0, GraphQLSliceable_1.makeRowFetcher)(sliceableFactoryParams, partialQueryVariables, client);
    return new PaginatedRowStore_1.PaginatedRowStore(queryRows);
}
//# sourceMappingURL=PaginatedQueryWrapper.js.map